import { createApi } from '@reduxjs/toolkit/query/react';
import baseApi from './base';
import paginationParams from 'utils/pagination-params';

export const list = 'LIST_LOBS';
export const single = 'SINGLE_LOB';

export const lobsApi = createApi({
  reducerPath: 'lobsApi',
  baseQuery: baseApi,
  tagTypes: [list, single],
  endpoints: (builder) => ({
    createLOB: builder.mutation({
      query: (lob) => ({
        url: '/lobs/create',
        method: 'POST',
        body: lob
      }),
      async onQueryStarted({ ownerName }, { dispatch, queryFulfilled }) {
        try {
          const { data: created } = await queryFulfilled;
          dispatch(
            lobsApi.util.updateQueryData('listLOBs', undefined, (draft) => {
              draft.data.items.unshift({ ...created.data, ...(ownerName && ownerName !== 'N/A' && { ownerName }) });
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    updateLOB: builder.mutation({
      query: ({ lobId, ...attributes }) => ({
        url: `/lobs/update/${lobId}`,
        method: 'POST',
        body: { ...attributes }
      }),
      invalidatesTags: [single],
      async onQueryStarted({ lobId, ownerName }, { dispatch, queryFulfilled }) {
        try {
          const { data: updated } = await queryFulfilled;
          dispatch(
            lobsApi.util.updateQueryData('listLOBs', undefined, (draft) => {
              const lob = draft.data.items.find((lob) => lob.id === lobId);
              if (lob) {
                Object.assign(lob, { ...updated.data, ...(ownerName && ownerName !== 'N/A' && { ownerName }) });
              }
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    getLOBById: builder.query({
      query: (lobId) => `/lobs/get/${lobId}`,
      providesTags: [single]
    }),
    listLOBs: builder.query({
      query: (params) => ({
        url: '/lobs/list',
        params
      }),
      providesTags: [list],
      ...paginationParams
    })
  })
});

export const { useCreateLOBMutation, useUpdateLOBMutation, useGetLOBByIdQuery, useListLOBsQuery } = lobsApi;
